import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 15\" id=\"close\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.012 8L14 13.988 12.987 15 7 9.012 1.012 15 0 13.988 5.987 8 0 2.012 1.012 1 7 6.988 12.987 1 14 2.012 8.012 8z\" fill-opacity=\".3\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.012 7L14 12.988 12.987 14 7 8.012 1.012 14 0 12.988 5.987 7 0 1.012 1.012 0 7 5.988 12.987 0 14 1.012 8.012 7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol